/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import {
  Grid,
  Row,
  Col,
  ControlLabel,
  Form,
  FormControl,
  FormGroup,
  Panel,
} from 'react-bootstrap';
import { Editor, EditorState } from 'draft-js';
import { Link } from 'react-router';
import { routerActions } from 'react-router-redux';
import IntlMsg from 'lorautils/intl/IntlMsg';
import ErrorSet from 'lorautils/errors/ErrorSet';
import { callAPI } from 'lorautils/api';
import RichButton from 'loracoms/RichButton';
import ControlTips from 'loracoms/ControlTips';
import FormBlock from 'loracoms/FormBlock';
import Toolbar from 'loracoms/Toolbar';
import Nvl from 'loracoms/Nvl';
import AddFlowHelp from '../AddFlowHelp';
import styles from './styles.scss';

const kMaxNameLen = 128;

const propTypes = {
  intl: React.PropTypes.object.isRequired,
  pushState: React.PropTypes.func.isRequired,
  appId: React.PropTypes.string.isRequired,
  appState: React.PropTypes.object.isRequired,
};

class AddFlow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      descState: EditorState.createEmpty(),
      scriptState: EditorState.createEmpty(),
      errors: (
        ErrorSet
          .createEmpty()
          .add('FE_EMPTY', 'name')
          .add('FE_EMPTY', 'script')
      ),
      appState: props.appState,
    };
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.flowsview.addflow');
    this.handleChangeName = this.handleChangeName.bind(this);
    this.handleChangeDesc = this.handleChangeDesc.bind(this);
    this.handleChangeScript = this.handleChangeScript.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { appState } = nextProps;
    if (appState !== this.props.appState) {
      this.setState({ appState });
    }
  }

  handleChangeName(e) {
    const name = e.target.value;
    this.setState({ name });

    const { errors } = this.state;
    if (name === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'name') });
    } else if (name.length > kMaxNameLen) {
      this.setState({ errors: errors.add('FE_TOOLONG', 'name') });
    } else {
      this.setState({ errors: errors.remove('name') });
    }
  }

  handleChangeDesc(descState) {
    this.setState({ descState });
  }

  handleChangeScript(scriptState) {
    this.setState({ scriptState });

    const { errors } = this.state;
    if (scriptState.getCurrentContent().hasText()) {
      this.setState({ errors: errors.remove('script') });
    } else {
      this.setState({ errors: errors.add('FE_EMPTY', 'script') });
    }
  }

  handleSubmit(e) {
    e.preventDefault();
    this.setState({ submitted: true });

    let { errors } = this.state;
    errors = errors.remove('submit');
    if (!errors.isEmpty()) {
      return;
    }

    const { appId, pushState } = this.props;
    const { name, descState, scriptState } = this.state;

    callAPI({
      endpoint: '/lora/flows',
      body: {
        name,
        desc: descState.getCurrentContent().getPlainText(),
        script: scriptState.getCurrentContent().getPlainText(),
        appid: appId,
      },
      method: 'POST',
    }).then(() => {
      this.setState({
        status: 'success',
        errors: errors.remove('submit'),
      });
      _.delay(() => pushState(`/application/${appId}/flows`), 100);
    }).catch((error) => {
      this.setState({
        status: 'failure',
        errors: errors.add(error.code, 'submit'),
      });
    });
  }

  renderToolbar() {
    const { pushState, appId } = this.props;
    const { appState } = this.state;
    const { status, data: { name = '' } = {} } = appState;
    const breadcrumb = [{
      content: this.intlMsg.globalMsg('application.breadcrumb.application'),
      onClick: () => pushState('/application'),
    }, {
      content: <Nvl val={name} status={status} />,
      onClick: () => pushState(`/application/${appId}/flows`),
    }, {
      content: this.intlMsg.msg('breadcrumb'),
      active: true,
    }];

    return <Toolbar breadcrumb={breadcrumb} />;
  }

  render() {
    const {
      name = '',
      descState,
      scriptState,
      highlight = false,
      status = '',
      submitted = false,
      errors,
    } = this.state;
    return (
      <Grid fluid>
        <Row>
          <Col md={12}>
            {this.renderToolbar()}
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <Panel
              bsStyle="aisz-info"
              header={this.intlMsg.msg('header')}
            >
              <Form horizontal onSubmit={this.handleSubmit}>
                <FormGroup validationState={submitted && errors.has('name') ? 'error' : undefined}>
                  <Col md={2}>
                    <ControlLabel bsClass="aisz-control-label">
                      {this.intlMsg.msg('name')}
                    </ControlLabel>
                  </Col>
                  <Col md={8}>
                    <FormControl
                      bsClass="aisz-form-control-f"
                      value={name}
                      onChange={this.handleChangeName}
                    />
                    <ControlTips
                      show={submitted && errors.has('name')}
                      message={this.intlMsg.errorMsg(errors.get('name'))}
                      azStyle="danger"
                    />
                  </Col>
                </FormGroup>
                <FormGroup>
                  <Col md={2}>
                    <ControlLabel bsClass="aisz-control-label">
                      {this.intlMsg.msg('desc')}
                    </ControlLabel>
                  </Col>
                  <Col md={8}>
                    <div className={styles.editor}>
                      <Editor
                        editorState={descState}
                        onChange={this.handleChangeDesc}
                      />
                    </div>
                  </Col>
                </FormGroup>
                <FormGroup validationState={submitted && errors.has('script') ? 'error' : undefined}>
                  <Col md={2}>
                    <ControlLabel bsClass="aisz-control-label">
                      {this.intlMsg.msg('script')}{' '}
                      <Link
                        className={styles.helpIcon}
                        onClick={() => { this.setState({ highlight: true }); }}
                      >
                        <i className="fa fa-question-circle" />
                      </Link>
                    </ControlLabel>
                  </Col>
                  <Col md={8}>
                    <div className={`${styles.editor} ${styles.scriptEditor}`}>
                      <Editor
                        editorState={scriptState}
                        onChange={this.handleChangeScript}
                      />
                    </div>
                    <ControlTips
                      show={submitted && errors.has('script')}
                      message={this.intlMsg.errorMsg(errors.get('script'))}
                      azStyle="danger"
                    />
                  </Col>
                </FormGroup>
                <FormGroup>
                  <Col mdOffset={2} md={8}>
                    <div className={styles.submit}>
                      <RichButton
                        status={status}
                        states={[{
                          status: 'default',
                          label: this.intlMsg.msg('submit'),
                          style: 'primary',
                          type: 'submit',
                        }, {
                          status: 'success',
                          label: this.intlMsg.msg('submit.success'),
                          style: 'success',
                          timer: () => { this.setState({ status: '' }); },
                        }, {
                          status: 'failure',
                          label: this.intlMsg.msg('submit.failure'),
                          style: 'danger',
                          timer: () => { this.setState({ status: '' }); },
                        }]}
                      />
                    </div>
                  </Col>
                </FormGroup>
                <FormGroup>
                  <Col mdOffset={2} md={8}>
                    <FormBlock
                      show={errors.has('submit')}
                      message={this.intlMsg.errorMsg(errors.get('submit'))}
                      azStyle="danger"
                    />
                  </Col>
                </FormGroup>
              </Form>
            </Panel>
          </Col>
          <Col md={6}>
            <AddFlowHelp
              highlight={highlight}
              onHighlightExited={() => { this.setState({ highlight: false }); }}
            />
          </Col>
        </Row>
      </Grid>
    );
  }
}

AddFlow.propTypes = propTypes;

const mapStateToProps = (state, ownProps) => ({
  appState: state.app.getApp,
  appId: ownProps.params.id,
});

const mapDispatchToProps = {
  pushState: routerActions.push,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(AddFlow));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/FlowsView/coms/AddFlow/index.jsx